/**
 * Counter part to *handleURLParams()* that resolves values that originaly came from URL Params.
 *
 * @export
 */
export function resolveSessionValues() {
    const pnr = sessionStorage.getItem("pnr");
    const dnr = sessionStorage.getItem("dnr");
    const encryptedCampaign = sessionStorage.getItem("awCampaign");

    if (!encryptedCampaign) {
        return { campaign: null, pnr, dnr };
    }

    const campaign = JSON.parse(atob(encryptedCampaign));

    return { campaign, pnr, dnr };
}
